import { syntaxHighlighting, HighlightStyle } from '@codemirror/language';
import { tags } from '@lezer/highlight';
import { ViewPlugin, Decoration, MatchDecorator } from '@codemirror/view';
import { RangeSetBuilder } from '@codemirror/state';

// Define the highlight style for inline comments
export const inlineCommentHighlightStyle = HighlightStyle.define([
    {
        tag: tags.comment,
        class: 'cm-inline-comment'
    }
]);

// Create a match decorator that finds lines starting with #
const inlineCommentMatcher = new MatchDecorator({
    regexp: /^#.*/gm,
    decoration: _match => Decoration.mark({
        class: 'cm-inline-comment'
    })
});

// ViewPlugin to apply inline comment decorations
const inlineCommentHighlightPlugin = ViewPlugin.fromClass(class {
    constructor(view) {
        this.decorations = this.buildDecorations(view);
    }

    update(update) {
        if (update.docChanged || update.viewportChanged) {
            this.decorations = this.buildDecorations(update.view);
        }
    }

    buildDecorations(view) {
        const builder = new RangeSetBuilder();
        const doc = view.state.doc;
        
        for (let { from, to } of view.visibleRanges) {
            for (let pos = from; pos <= to;) {
                const line = doc.lineAt(pos);
                
                // Check if line starts with # (allowing for leading whitespace)
                if (line.text.trimStart().startsWith('#')) {
                    // Add line decoration for CSS targeting (removes padding)
                    builder.add(line.from, line.from, Decoration.line({
                        class: 'cm-inline-comment'
                    }));
                    
                    // Add mark decoration for text styling
                    builder.add(line.from, line.to, Decoration.mark({
                        class: 'cm-inline-comment'
                    }));
                }
                
                pos = line.to + 1;
            }
        }
        
        return builder.finish();
    }
}, {
    decorations: v => v.decorations
});

// Export the extension
export const inlineCommentExtension = [
    inlineCommentHighlightPlugin,
    syntaxHighlighting(inlineCommentHighlightStyle)
];